"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActionName = void 0;

/**
 * @namespace skybase-core.utils.get-action-name
 */

/**
 * @description
 * function adds <code>@@skybase/</code> or custom prefix to action name
 * @Function
 *
 * @name skybase-core.utils.get-action-name#getActionName
 * @param  {String} name - Action name.
 * @param  {String} prefix - Prefix name.
 * @return {String} - New generated action name with prefix.
 */
var getActionName = function getActionName(name) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'skybase';
  return "@@".concat(prefix, "/").concat(name);
};

exports.getActionName = getActionName;
//# sourceMappingURL=get-action-name.js.map